module.exports = __webpack_public_path__ + "static/media/logo.889282ed.png";